/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeChartLegend } from "../../d-chart-legend";
import { DThemeDarkBase } from "./d-theme-dark-base";

export class DThemeDarkChartLegend extends DThemeDarkBase implements DThemeChartLegend {}
